export default __webpack_public_path__ + "static/media/evreux12.70ae8ee7.jpg";